import {
  INITIALIZE_CONFIG,
} from '../actions/types';

export default function config(state = {}, action) {
  switch (action.type) {
    case INITIALIZE_CONFIG: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
